import TaskList from "@tiptap/extension-task-list";

export const NeueTaskList = TaskList.extend({
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51,
      },
      {
        // parsing google doc checklist items
        tag: `ul`,
        priority: 52,
        getAttrs: (element) => {
          const children = (element as HTMLElement).children;
          if (children.length !== 0) {
            for (let i = 0; i < children.length; i++) {
              const child = children[i];
              if (child.getAttribute('role') !== 'checkbox') {
                return false
              }
            }
            return null
          } else {
            return false
          }
        }
      },
      {
        // parsing notion checklist items
        tag: 'ul',
        priority: 52,
        getAttrs: (element) => {
          const children = (element as HTMLElement).children;
          if (children.length !== 0) {
            for (let i = 0; i < children.length; i++) {
              const text = children[i].textContent;
              if (!text?.startsWith('[ ]') && !text?.startsWith('[x]')) {
                return false
              }
            }
            return null
          } else {
            return false
          }
        }
      }
    ]
  }
}
);